import Vue from "vue";
import Router from "vue-router";

// import pageHome from './views/page-home.vue' // 首页
// import pageMemberManage from './views/page-member-manage' //会员管理页
// import pageOrderCare from './views/page-order-care' //订单关怀

Vue.use(Router);

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

export default new Router({
  mode: "history",
  // mode: "hash",
  base: process.env.BASE_URL,
  routes: [
    // {
    //   path: "/",
    //   redirect: "/login",
    // },
    {
      path: "/redirection",
      name: "redirection",
      component: (resolve) => {
        require(["./views/redirection.vue"], resolve);
      },
    },
    {
      path: "/refresh",
      name: "refresh",
      component: (resolve) => {
        require(["./views/refresh.vue"], resolve);
      },
    },
    {
      path: "*",
      redirect: '/integralCenter'
    },
    // {
    //   path: "/home",
    //   name: "home",
    //   component: (resolve) => {
    //     require(["./views/home/page_home.vue"], resolve);
    //   },
    // },
    {
      path: "/prizeCenter", //积分授权页面
      name: "prizeCenter",
      component: (resolve) => {
        require(["./views/integralCenter/prizeCenter.vue"], resolve);
      },
    },
    {
      path: "/prizeCenter2", //积分授权页面
      name: "prizeCenter2",
      component: (resolve) => {
        require(["./views/integralCenter/prizeCenter2.vue"], resolve);
      },
    },
    {
      path: "/login",
      name: "home",
      component: (resolve) => {
        require(["./views/login/login.vue"], resolve);
      },
    },
    {
      path: "/manage",
      name: "manage",
      component: (resolve) => {
        require(["./views/router_page.vue"], resolve);
      },
      children: [
        {
          path: "",
          redirect: { name: "focusShop" },
        },
        {
          path: "manage",
          redirect: { name: "focusShop" },
          component: (resolve) => {
            require(["./views/router_page1.vue"], resolve);
          },
          children: [
            {
              path: "",
              redirect: { name: "focusShop" },
            },
            {
              path: "focusShop",
              name: "focusShop",
              component: (resolve) => {
                require(["./views/manage/focusShop.vue"], resolve);
              },
            },
            {
              path: "focus_merchandise",
              name: "focus_merchandise",
              component: (resolve) => {
                require(["./views/manage/focus_merchandise.vue"], resolve);
              },
            },
            {
              path: "share_polite",
              name: "share_polite",
              component: (resolve) => {
                require(["./views/manage/share_polite.vue"], resolve);
              },
            },
            {
              path: "grouping",
              name: "grouping",
              component: (resolve) => {
                require(["./views/manage/grouping.vue"], resolve);
              },
            },
          ],
        },
        // 标签管理
        {
          path: "labelManage",
          redirect: { name: "labelManage" },
          component: (resolve) => {
            require(["./views/router_page1.vue"], resolve);
          },
          children: [
            {
              path: "",
              redirect: { name: "labelManage" },
            },
            {
              path: "labelManage",
              name: "labelManage",
              component: (resolve) => {
                require(["./views/manage/label_manage.vue"], resolve);
              },
            },
            {
              path: "automatic_marking",
              name: "automatic_marking",
              component: (resolve) => {
                require(["./views/manage/automatic_marking.vue"], resolve);
              },
            },
          ],
        },
      ],
    },
    //客户营销
    {
      path: "/marketing",
      component: (resolve) => {
        require(["./views/router_page.vue"], resolve);
      },
      children: [
        {
          path: "",
          redirect: { name: "groupingX" },
        },
        {
          path: "marketing",
          redirect: { name: "groupingX" },
          component: (resolve) => {
            require(["./views/router_page1.vue"], resolve);
          },
          children: [
            {
              path: "",
              redirect: { name: "grouping" },
            },
            {
              path: "grouping",
              name: "groupingX",
              component: (resolve) => {
                require(["./views/manage/grouping.vue"], resolve);
              },
            },
            {
              path: "member_grouping",
              name: "member_grouping",
              component: (resolve) => {
                require(["./views/manage/member_grouping.vue"], resolve);
              },
            },
            {
              path: "black_list",
              name: "black_list",
              component: (resolve) => {
                require(["./views/manage/black_list.vue"], resolve);
              },
            },
            {
              path: "order_sent",
              name: "order_sent",
              component: (resolve) => {
                // require(['./views/marketing/order_sent.vue'], resolve)
                require(["./views/manage/marketing_record.vue"], resolve);
              },
              meta: {
                desc: "订单发送",
                typeIndex: 5, // 5.表示订单发送
              },
            },
            {
              path: "sms_record",
              name: "sms_record",
              component: (resolve) => {
                require(["./views/manage/sms_record.vue"], resolve);
              },
            },
            {
              path: "accurate_market",
              name: "accurate_market",
              component: (resolve) => {
                // require(['./views/manage/accurate_market.vue'], resolve)
                require(["./views/manage/marketing_record.vue"], resolve);
              },
              meta: {
                desc: "精准营销",
                typeIndex: 1, // 1.表示精准营销
              },
            },
            {
              path: "intelligent_market",
              name: "intelligentMarket",
              component: (resolve) => {
                // 智能营销
                require(["./views/intelligentMarket/index.vue"], resolve);
              }
            },
            //高级发送-start
            {
              path: "sendHeight",
              name: "sendHeight",
              component: (resolve) => {
                //高级发送
                require(["./views/intelligentMarket/sendHeight.vue"], resolve);
              }
            },
            //高级发送-end
            {
              path: '/miDetal',
              name: 'miDetal',
              component: (resolve) => {
                require(['./views/intelligentMarket/Detail.vue'], resolve)
              }
            },
            {
              path: "member_send",
              name: "member_send",
              component: (resolve) => {
                // require(['./views/manage/member_send.vue'], resolve)
                require(["./views/manage/marketing_record.vue"], resolve);
              },
              meta: {
                desc: "会员发送",
                typeIndex: 2, // 2.表示精准营销
              },
            },
            {
              path: "designated_send",
              name: "designated_send",
              component: (resolve) => {
                // require(['./views/manage/designated-send.vue'], resolve)
                require(["./views/manage/marketing_record.vue"], resolve);
              },
              meta: {
                desc: "指定号码发送",
                typeIndex: 3, // 3.指定号码发送
              },
            },
            {
              path: "variables-send",
              name: "variables-send",
              component: (resolve) => {
                // require(['./views/manage/variables_send.vue'], resolve)
                require(["./views/manage/marketing_record.vue"], resolve);
              },
              meta: {
                desc: "变量短信发送",
                typeIndex: 4, // 4.变量短信发送
              },
            },
            // {
            //   path: 'marketing-record',
            //   name: 'marketing-record',
            //   component: (resolve) => {
            //     require(['./views/manage/marketing_record.vue'], resolve)
            //   },
            // },
            {
              path: "summary-analysis",
              name: "summary-analysis",
              component: (resolve) => {
                require(["./views/manage/summary_analysis.vue"], resolve);
              },
            },
          ],
        },
        // 自动化营销
        {
          path: "auto_marketing",
          redirect: { name: "商品复购" },
          component: (resolve) => {
            require(["./views/manage/autoMarket/index.vue"], resolve);
          },
          children: [
            {
              path: "goods_repurchase",
              name: "商品复购",
              component: (resolve) => {
                require(["./views/manage/autoMarket/auto_market.vue"], resolve);
              },
              meta: {
                desc:
                  "根据商品的消耗周期，在商品即将消耗完的时候发送提醒，引导复购",
                itemIndex: 1,
                taskType: 25,
                isOfficial: true,
                officialType: '20',
                smsLabel: [
                  "#买家昵称#",
                  "#会员等级#",
                  "#最近一次购买时间#",
                  "#交易总额#",
                  "#交易笔数#",
                  "#距今多久未购买#",
                ],
              },
            },
            {
              path: "first_purchase",
              name: "首单专享礼",
              component: (resolve) => {
                require(["./views/manage/autoMarket/auto_market.vue"], resolve);
              },
              meta: {
                desc:
                  "对首次在店铺购买的客户发送关怀，或者推送搭配商品，引导复购",
                itemIndex: 2,
                isOfficial: true,
                officialType: '20',
                taskType: 15,
                smsLabel: [
                  "#买家昵称#",
                  "#最近一次购买时间#",
                  "#交易总额#",
                  "#交易笔数#",
                ],
              },
            },
            {
              path: "repurchase",
              name: "复购有礼",
              component: (resolve) => {
                require(["./views/manage/autoMarket/auto_market.vue"], resolve);
              },
              meta: {
                desc: "对再次进店购买的客户发送关怀，引导下次进店复购",
                itemIndex: 3,
                taskType: 16,
                isOfficial: true,
                officialType: '20',
                smsLabel: [
                  "#买家昵称#",
                  "#会员等级#",
                  "#最近一次购买时间#",
                  "#交易总额#",
                  "#交易笔数#",
                  "#距今多久未购买#",
                ],
              },
            },
            {
              path: "sleep_remind",
              name: "休眠提醒",
              component: (resolve) => {
                require(["./views/manage/autoMarket/auto_market.vue"], resolve);
              },
              meta: {
                desc:
                  "对长时间没有进店购买的客户发送短信关怀，唤醒客户记忆回店购买",
                itemIndex: 4,
                taskType: 17,
                isOfficial: true,
                officialType: '20',
                smsLabel: [
                  "#买家昵称#",
                  "#会员等级#",
                  "#最近一次购买时间#",
                  "#交易总额#",
                ],
              },
            },
            {
              path: "fullmonthgift",
              name: "满月礼",
              component: (resolve) => {
                require(["./views/manage/autoMarket/auto_market.vue"], resolve);
              },
              meta: {
                desc:
                  "在距离客户首次购买满30天的时候发送短信关怀，引导进店复购",
                itemIndex: 5,
                taskType: 18,
                isOfficial: true,
                officialType: '20',
                smsLabel: [
                  "#买家姓名#",
                  "#买家昵称#",
                  "#会员等级#",
                  "#最近一次购买时间#",
                  "#最早购买时间#",
                  "#交易总额#",
                ],
              },
            },
            {
              path: "hundred_day_gift",
              name: "百日礼",
              component: (resolve) => {
                require(["./views/manage/autoMarket/auto_market.vue"], resolve);
              },
              meta: {
                desc:
                  "距离客户购买满100天的时候，发送一条关怀短信，引导进店复购",
                itemIndex: 6,
                taskType: 19,
                isOfficial: true,
                officialType: '20',
                smsLabel: [
                  "#买家姓名#",
                  "#买家昵称#",
                  "#会员等级#",
                  "#最近一次购买时间#",
                  "#最早购买时间#",
                  "#交易总额#",
                ],
              },
            },
            {
              path: "anniversary",
              name: "周年庆",
              component: (resolve) => {
                require(["./views/manage/autoMarket/auto_market.vue"], resolve);
              },
              meta: {
                desc: "距离客户购买满1年的时候,发送一条关怀短信，引导进店复购",
                itemIndex: 7,
                taskType: 20,
                isOfficial: true,
                officialType: '20',
                smsLabel: [
                  "#买家姓名#",
                  "#买家昵称#",
                  "#会员等级#",
                  "#最近一次购买时间#",
                  "#最早购买时间#",
                  "#交易总额#",
                ],
              },
            },
            {
              path: "memberbill",
              name: "会员账单",
              component: (resolve) => {
                require(["./views/manage/autoMarket/auto_market.vue"], resolve);
              },
              meta: {
                desc:
                  "开启后，给店铺客户自动发送月度消费账单，引导进店复购享受优惠",
                itemIndex: 8,
                taskType: 21,
                smsLabel: [
                  "#买家昵称#",
                  " #会员等级#",
                  "#最近一次购买时间#",
                  "#距今多久未购买#",
                  "#交易总额#",
                  "#交易笔数#",
                ],
              },
            }, 
            {
              path: "activity",
              name: "活动码",
              component: (resolve) => {
                require(["./views/manage/autoMarket/activity.vue"], resolve);
              },
              meta: {
                desc:
                  "开启后，给店铺客户自动发送上月账单，提醒买家进店享受优惠",
                itemIndex: 9,
                smsLabel: [
                  "#订单号#",
                  "#收货人姓名#",
                  "#买家昵称#",
                  "#下单时间#",
                  "#订单金额#",
                  "#活动码#",
                ],
              },
            },
          ],
        },
        // 自动化营销 （官方） 
        {
          path: "auto_marketing_official",
          redirect: { name: "goods_repurchase" },
          component: (resolve) => {
            require(["./views/router_page1.vue"], resolve);
          },
          children: [
            {
              path: "first_purchase_official",
              name: "first_purchase_official",
              component: (resolve) => {
                require(["./views/manage/auto_market_official.vue"], resolve);
              },
              meta: {
                desc:
                  "对首次在店铺成交的客户发送关怀，或者推送搭配商品，引导复购",
                itemIndex: 1,
              },
            },
            {
              path: "reminder_purchase_official",
              name: "reminder_purchase_official",
              component: (resolve) => {
                require(["./views/manage/auto_market_official.vue"], resolve);
              },
              meta: {
                desc: "针对多天未成交的客户，发送一条促销短信，提醒客户进行复购",
                itemIndex: 2,
              },
            },
            {
              path: "call_customer_churn",
              name: "call_customer_churn",
              component: (resolve) => {
                require(["./views/manage/auto_market_official.vue"], resolve);
              },
              meta: {
                desc: "客户超过180天未成交，自动发送关怀，唤醒客户记忆进店购买",
                itemIndex: 3,
              },
            },
            {
              path: "interest_customer_conversion",
              name: "interest_customer_conversion",
              component: (resolve) => {
                require(["./views/manage/auto_market_official.vue"], resolve);
              },
              meta: {
                desc: "近期有加购或者关注但无成交的客户持续转化",
                itemIndex: 4,
              },
            },
            {
              path: "conversion_unpurchased_members",
              name: "conversion_unpurchased_members",
              component: (resolve) => {
                require(["./views/manage/auto_market_official.vue"], resolve);
              },
              meta: {
                desc: "针对开卡入会一定时间后未购买的客户进行主动营销，提升转化率",
                itemIndex: 5,
              },
            },
          ],
        },
        {
          path: "chat",
          redirect: { name: "chat_Marketing" },
          component: (resolve) => {
            require(["./views/router_page1.vue"], resolve);
          },
          children: [
            {
              path: "chat_Marketing",
              name: "chat_Marketing",
              component: (resolve) => {
                require(["./views/manage/group_chart_market.vue"], resolve);
              },
            },
          ]
        }
      ],
    },
    //数据分析
    {
      path: "/analysis",
      component: (resolve) => {
        require(["./views/router_page.vue"], resolve);
      },
      children: [
        {
          path: "",
          redirect: { name: "customerAnalysisSelfSupport" },
        },
        {
          path: 'customerAnalysisSelfSupport',
          redirect: { name: 'customerAnalysisSelfSupport' },
          component: (resolve) => {
            require(['./views/router_page1.vue'], resolve)
          },
          children: [
            {
              path: '',
              redirect: { name: 'customerAnalysisSelfSupport' },
            },
            {
              path: "customerAnalysisSelfSupport",
              name: "customerAnalysisSelfSupport",
              component: (resolve) => {
                require(["./views/analysis/customerAnalysisSelfSupport.vue"], resolve);
              },
            },
            {
              path: 'marketing_insight',
              name: 'marketing_insight',
              component: (resolve) => {
                require(['./views/analysis/marketing_insight.vue'], resolve)
              },
            },
          ]
        },
        {
          path: "customerAnalysis",
          redirect: { name: "customer_portrait" },
          component: (resolve) => {
            require(["./views/router_page1.vue"], resolve);
          },
          children: [
            // {
            //   path: 'customer_portrait',
            //   name: 'customer_portrait',
            //   component: (resolve) => {
            //     require(['./views/analysis/customer_portrait.vue'], resolve)
            //   },
            // },
            {
              path: "people_level",
              name: "people_level",
              component: (resolve) => {
                require(["./views/analysis/people_level.vue"], resolve);
              },
            },
            {
              path: "marketing_insight",
              name: "marketing_insight",
              component: (resolve) => {
                require(["./views/analysis/marketing_insight.vue"], resolve);
              },
            },
            {
              path: "regional_analysis",
              name: "regional_analysis",
              component: (resolve) => {
                require(["./views/analysis/regional_analysis.vue"], resolve);
              },
            },
            {
              path: "amount_analysis",
              name: "amount_analysis",
              component: (resolve) => {
                require(["./views/analysis/amount_analysis.vue"], resolve);
              },
            },
            {
              path: "monthly_report",
              name: "月度报表",
              component: (resolve) => {
                require(["./views/analysis/monthly_report.vue"], resolve);
              },
            },
          ],
        },
        {
          path: "rfmAnalysis",
          redirect: { name: "RFM分析" },
          component: (resolve) => {
            require(["./views/router_page1.vue"], resolve);
          },
          children: [
            {
              path: "RFM_standard_analysis",
              name: "RFM标准分析",
              component: (resolve) => {
                require([
                  "./views/analysis/RFM_standard_analysis.vue",
                ], resolve);
              },
            },
            {
              path: "RFM_custom_analysis",
              name: "RFM自定义分析",
              component: (resolve) => {
                require(["./views/analysis/RFM_custom_analysis.vue"], resolve);
              },
            },
          ],
        },
        {
          path: "goods",
          redirect: { name: "商品回购周期分析" },
          component: (resolve) => {
            require(["./views/router_page1.vue"], resolve);
          },
          children: [
            {
              path: "goods_repurchase",
              name: "商品回购周期分析",
              component: (resolve) => {
                require(["./views/analysis/goods_repurchase.vue"], resolve);
              },
            },
            {
              path: "goods_combine",
              name: "商品销售连带分析",
              component: (resolve) => {
                require(["./views/analysis/goods_combine.vue"], resolve);
              },
            },
          ],
        },
      ],
    },
    //后台管理
    {
      path: "/backstage",
      component: (resolve) => {
        require(["./views/router_page.vue"], resolve);
      },
      children: [
        {
          path: "",
          redirect: { name: "sms_management" },
        },
        {
          path: "backstage",
          redirect: { name: "sms_management" },
          component: (resolve) => {
            require(["./views/router_page1.vue"], resolve);
          },
          children: [
            {
              path: "",
              redirect: { name: "sms_management" },
            },
            {
              path: "sms_management",
              name: "sms_management",
              component: (resolve) => {
                require(["./views/backstage/sms_management.vue"], resolve);
              },
            },
            {
              path: "sms_reply_record",
              name: "sms_reply_record",
              component: (resolve) => {
                require(["./views/backstage/sms_reply_record.vue"], resolve);
              },
            },
            {
              path: "sms_bill",
              name: "sms_bill",
              component: (resolve) => {
                require(["./views/backstage/sms_bill.vue"], resolve);
              },
            },
            {
              path: "sms_module",
              name: "smsModule",
              component: (resolve) => {
                require(["./views/backstage/sms_module.vue"], resolve);
              },
            },
          ],
        },
        //系统设置
        {
          path: "account",
          redirect: { name: "account" },
          component: (resolve) => {
            require(["./views/router_page1.vue"], resolve);
          },
          children: [
            {
              path: "",
              redirect: { name: "account" },
            },
            {
              path: "account",
              name: "account",
              component: (resolve) => {
                require(["./views/backstage/account_settings.vue"], resolve);
              },
            },
            {
              path: "store_binding",
              name: "store_binding",
              component: (resolve) => {
                require(["./views/backstage/store_binding.vue"], resolve);
              },
            },
          ],
        },
        //签名报备
        {
          path: "signature_management",
          redirect: { name: "signature_management" },
          component: (resolve) => {
            require(["./views/router_page1.vue"], resolve);
          },
          children: [
            {
              path: "",
              redirect: { name: "signature_management" },
            },
            {
              path: "signature_management",
              name: "signature_management",
              component: (resolve) => {
                require([
                  "./views/backstage/signature_management.vue",
                ], resolve);
              },
            },
            {
              path: "signature_report_official",
              name: "signature_report_official",
              component: (resolve) => {
                require([
                  "./views/backstage/signature_report_official.vue",
                ], resolve);
              },
            },
          ],
        },
        //签名设置
        // {
        //   name: 'signature_set',
        //   path: 'signature_set',
        //   component: (resolve) => {
        //     require(['./views/backstage/signature_set.vue'], resolve)
        //   }
        // },
        //帮助中心
        // {
        //   path: 'online_service',
        //   name: 'online_service',
        //   component: (resolve) => {
        //     require(['./views/backstage/online_service.vue'], resolve)
        //   }
        // },
        //邀请好友赚积分
        {
          name: "invite_friends",
          path: "invite_friends",
          component: (resolve) => {
            require(["./views/backstage/invite_friends.vue"], resolve);
          },
        },
      ],
    },
    //积分中心
    {
      path: "/integralCenter",
      component: (resolve) => {
        require(["./views/router_page.vue"], resolve);
      },
      children: [
        {
          path: "",
          redirect: { name: "newhome" },
        },
        {
          path: "integralCenter",
          redirect: { name: "mutualMember" },
          component: (resolve) => {
            require(["./views/router_page1.vue"], resolve);
          },
          children: [
            {
              path: "",
              redirect: { name: "mutualMember" },
            },
            {
              path: "mutualMember",
              name: "mutualMember",
              component: (resolve) => {
                require([
                  "./views/integralCenter/memberCenter/mutualMember.vue",
                ], resolve);
              },
            },
            {
              path: "memberLevel",
              name: "memberLevel",
              component: (resolve) => {
                require([
                  "./views/integralCenter/memberCenter/memberLevel.vue",
                ], resolve);
              },
            },
            {
              path: "memberPower",
              name: "memberPower",
              component: (resolve) => {
                require([
                  "./views/integralCenter/memberCenter/memberPower.vue",
                ], resolve);
              },
            },
          ],
        },
        {
          path: 'integralEden/iou',
          name: 'iou',
          component: (resolve) => {
            require(['./views/integralCenter/iou/index.vue'], resolve)
          }
        },
        {
          path: "home",
          name: "newhome",
          component: (resolve) => {
            require(["./views/integralCenter/NewHome/page_home.vue"], resolve);
          },
        },
        {
          path: "integralTask",
          name: "integralTask",
          component: (resolve) => {
            require(["./views/integralCenter/integralTask.vue"], resolve);
          },
        },
        {
          path: "integralEden",
          name: "integralEden",
          component: (resolve) => {
            require(["./views/integralCenter/integralEden.vue"], resolve);
          },
        },
        {
          path: "integralCenter/shopDecoration",
          name: "shopDecoration",
          component: (resolve) => {
            require(["./views/integralCenter/shopDecoration.vue"], resolve);
          },
        },
        { // 会员等级权益
          path: "integralCenter/memberShipLevel",
          name: "memberShipLevel",
          component: (resolve) => {
            require(["./views/integralCenter/memberShipLevel.vue"], resolve);
          },
        },
        {
          path: "integralMall",
          name: "integralMall",
          component: (resolve) => {
            require(["./views/integralCenter/integralMall.vue"], resolve);
          },
        },
        {
          path: "gameHub",
          name: "gameHub",
          component: (resolve) => {
            require(["./views/integralCenter/gameHub.vue"], resolve);
          },
        },
        // 小部件 0元试用
        {
          path: "cardManage/freeTrial",
          name: "freeTrial?activityType=33",
          component: (resolve) => {
            require(["./views/integralCenter/cardManage/scratchers.vue"], resolve);
          },
        },
        {
          path: "cardManage/freeTrialEdit",
          name: "freeTrialEdit",
          meta: {
            activeMange: 'freeTrial?activityType=33'
          },
          component: (resolve) => {
            require(["./views/integralCenter/cardManage/points_task_freeTrial.vue"], resolve);
          },
        },
        // 小部件 会员卡片
        {
          path: "cardManage/memberCard",
          name: "memberCard?activityType=32",
          component: (resolve) => {
            require(["./views/integralCenter/cardManage/scratchers.vue"], resolve);
          },
        },
        {
          path: "cardManage/memberCardEdit",
          name: "memberCardEdit",
          meta: {
            activeMange: 'memberCard?activityType=32'
          },
          component: (resolve) => {
            require(["./views/integralCenter/cardManage/points_task_memberCard.vue"], resolve);
          },
        },
        // 小部件 刮刮乐
        {
          path: "cardManage/scratchers",
          name: "scratchers?activityType=26",
          component: (resolve) => {
            require(["./views/integralCenter/cardManage/scratchers.vue"], resolve);
          },
        },
        {
          path: "cardManage/scratchersEdit",
          name: "scratchersEdit",
          meta: {
            activeMange: 'scratchers?activityType=26'
          },
          component: (resolve) => {
            require(["./views/integralCenter/cardManage/points_task_scratchers.vue"], resolve);
          },
        },
        // 海报
        {
          path: "cardManage/smartPoster",
          name: "smartPoster?activityType=25",
          component: (resolve) => {
            require(["./views/integralCenter/cardManage/scratchers.vue"], resolve);
          },
        },
        {
          path: "cardManage/smartPosterEdit",
          name: "smartPosterEdit",
          meta: {
            activeMange: 'smartPoster?activityType=25'
          },
          component: (resolve) => {
            require(["./views/integralCenter/cardManage/points_task_smartPoster.vue"], resolve);
          },
        },
        //奖品中心
        {
          path: 'prizeCenter',
          component: (resolve) => {
            require(['./views/router_page1.vue'], resolve)
          },
          children: [
            {
              path: '',
              redirect: { name: 'prizeCenter' }
            },
            {
              path: 'coupon_management',
              name: 'coupon_management',
              component: (resolve) => {
                require(['./views/integralCenter/coupon_management.vue'], resolve)
              }
            },
            {
              path: 'asset_management',
              name: 'asset_management',
              component: (resolve) => {
                require(['./views/integralCenter/asset_management.vue'], resolve)
              }
            },
            {
              path: 'goods_management',
              name: 'goods_management',
              component: (resolve) => {
                require(['./views/integralCenter/physical/physical_management.vue'], resolve)
              }
            },
            {
              path: 'benefit-batch-send',
              name: 'benefit-batch-send',
              component: (resolve) => {
                require(['./views/integralCenter/benefitSend/index.vue'], resolve)
              }
            },
          ],
        },
        //推广方式
        {
          path: 'promotionMode',
          component: (resolve) => {
            require(['./views/router_page1.vue'], resolve)
          },
          children: [
            {
              path: '',
              redirect: { name: 'promotionMode' }
            },
            {
              path: 'suspension_diagram',
              name: 'suspension_diagram',
              component: (resolve) => {
                require(['./views/integralCenter/suspension_diagram1.vue'], resolve)
              }
            },
            {
              path: "other_promotion", //  推广页
              name: "other_promotion",
              component: (resolve) => {
                require(["./views/integralCenter/otherPromotion/index.vue"], resolve);
              },
            },
          ]
        },
        {
          path: "dataAnalysis",
          // redirect:{ name:'dataAnalysis' },
          component: (resolve) => {
            require(["./views/router_page1.vue"], resolve);
          },
          children: [
            {
              path: "",
              redirect: { name: "dataAnalysis" },
            },
            {
              path: "flow_analysis",
              name: "flow_analysis",
              component: (resolve) => {
                require(["./views/integral/flow_analysis.vue"], resolve);
              },
            },
            {
              path: "prize_statistics",
              name: "prize_statistics",
              component: (resolve) => {
                require(["./views/integral/prize_statistics.vue"], resolve);
              },
            },
          ],
        },
        {
          path: "brandCustom", // 品牌定制
          name: "brandCustom",
          component: (resolve) => {
            require(["./views/router_page1.vue"], resolve);
          },
          children: [
            {
              path: "",
              name: "",
              component: (resolve) => {
                require(["./views/brandCustom/index.vue"], resolve);
              },
            },
            {
              path: "brandMemberCenter",
              name: "brandMemberCenter",
              component: (resolve) => {
                require(["./views/brandCustom/brandMemberCenter.vue"], resolve);
              },
            },
            {
              path: "birthdayBenefit",
              name: "birthdayBenefit",
              component: (resolve) => {
                require(["./views/brandCustom/birthdayBenefit.vue"], resolve);
              },
            },
            {
              path: "starWallpapers",
              name: "starWallpapers",
              component: (resolve) => {
                require(["./views/starWallpapers/index.vue"], resolve);
              },
            },
          ],
        },
        {
          path: "activityManage", // 总活动列表
          name: "activityManage",
          component: (resolve) => {
            require(["./views/integralCenter/manage/index.vue"], resolve);
          },
        },
        // 中奖名单
        {
          path: "winReport",
          name: "winReport",
          component: (resolve) => {
            require(["./views/router_page.vue"], resolve);
          },
          children:[
            // 中奖名单-列表装修
            {
              path: "winListDecoration",
              name: "winListDecoration",
              component: (resolve) => {
                require(["./views/integralCenter/winList/finish.vue"], resolve)
              },
            },
            // 中奖名单-名单列表
            {
              path: "winReportList",
              name: "winReportList",
              component: (resolve) => {
                require(["./views/integralCenter/winList/winRecords.vue"], resolve)
              },
            },
          ]
        },
        {
          path: "integralMall/cardManageActivityList", // 活动列表
          name: "cardManageActivityList",
          component: (resolve) => {
            require(["./views/integralCenter/gift_list_2.vue"], resolve);
          },
          meta: {
            activityNewMainTypes:1
          }
        },
        // 活动页
        {
          path: "integralTask/dailyActivityList", // 活动列表
          name: "dailyActivityList",
          component: (resolve) => {
            require(["./views/integralCenter/activityManage.vue"], resolve);
          },
          meta: {
            activityNewMainTypes:1
          }
        },
        // 活动页
        {
          path: "integralTask/birthDayGift", // 生日有礼
          name: "birthDayGift",
          component: (resolve) => {
            require(["./views/integralCenter/actask/index.vue"], resolve);
          },
          meta: {
            activityType:39
          }
        }, 
        // 活动页
        {
          path: "integralTask/checkIn", // 签到赢好礼
          name: "checkIn",
          component: (resolve) => {
            require(["./views/integralCenter/actask/index.vue"], resolve);
          },
          meta: {
            activityType:1
          }
        }, 
        // 活动页
        {
          path: "integralTask/giftEveryDay", // 每日限时抢
          name: "giftEveryDay",
          component: (resolve) => {
            require(["./views/integralCenter/actask/index.vue"], resolve);
          },
          meta: {
            activityType:2
          }
        }, 
        {
          path: "integralTask/followShop", // 关注店铺有礼
          name: "followShop",
          component: (resolve) => {
            require(["./views/integralCenter/actask/index.vue"], resolve);
          },
          meta: {
            activityType:3
          }
        }, 
        {
          path: "integralTask/improveInformation", // 完善信息有礼
          name: "improveInformation",
          component: (resolve) => {
            require(["./views/integralCenter/actask/index.vue"], resolve);
          },
          meta: {
            activityType:6
          }
        }, 
        {
          path: "integralTask/incentivesForAddCart", // 加购有礼
          name: "incentivesForAddCart",
          component: (resolve) => {
            require(["./views/integralCenter/actask/index.vue"], resolve);
          },
          meta: {
            activityType:34
          }
        },
        {
          path: "integralTask/memberUpgradeGift", // 会员升级礼
          name: "memberUpgradeGift",
          component: (resolve) => {
            require(["./views/integralCenter/actask/index.vue"], resolve);
          },
          meta: {
            activityType:44
          }
        },
        {
          path: "integralTask/brithDay", // 生日有礼
          name: "incentivesForAddCart",
          component: (resolve) => {
            require(["./views/integralCenter/actask/index.vue"], resolve);
          },
          meta: {
            activityType:39
          }
        },  
        {
          path: "integralEden/wirlessActivityList", // 无线营销  活动列表
          name: "wirlessActivityList",
          component: (resolve) => {
            require(["./views/integralCenter/activityManage.vue"], resolve);
          },
          meta: {
            activityNewMainTypes:2
          }
        }, 
        {
          path: "integralEden/cardGiftBag", // 开卡礼包
          name: "cardGiftBag",
          component: (resolve) => {
            require(["./views/integralCenter/actask/index.vue"], resolve);
          },
          meta: {
            activityType:13
          }
        }, 
        {
          path: "integralEden/sendReBuy", // 派样回购礼（定制）
          name: "sendReBuy",
          component: (resolve) => {
            require(["./views/integralCenter/actask/index.vue"], resolve);
          },
          meta: {
            activityType:37
          }
        }, 
        {
          path: "integralEden/promoSendReBuy", // 派样回购礼（随单发）
          name: "promoSendReBuy",
          component: (resolve) => {
            require(["./views/integralCenter/actask/index.vue"], resolve);
          },
          meta: {
            activityType:42
          }
        }, 
        {
          path: "integralEden/pointLockAuth", // 积分锁权
          name: "pointLockAuth",
          component: (resolve) => {
            require(["./views/integralCenter/actask/index.vue"], resolve);
          },
          meta: {
            activityType:35
          }
        }, 
        {
          path: "integralEden/shopGiftBag", // 店铺礼包
          name: "shopGiftBag",
          component: (resolve) => {
            require(["./views/integralCenter/actask/index.vue"], resolve);
          },
          meta: {
            activityType:14
          }
        }, 
        {
          path: "integralEden/shopGiftBagTptn", // 店铺礼包千人千面
          name: "shopGiftBagTptn",
          component: (resolve) => {
            require(["./views/integralCenter/actask/index.vue"], resolve);
          },
          meta: {
            activityType:15
          }
        }, 
        {
          path: "integralEden/presellPolitely", // 预售有礼
          name: "presellPolitely",
          component: (resolve) => {
            require(["./views/integralCenter/actask/index.vue"], resolve);
          },
          meta: {
            activityType:27
          }
        }, 
        {
          path: "integralEden/presellLottery", // 预售抽奖
          name: "presellLottery",
          component: (resolve) => {
            require(["./views/integralCenter/actask/index.vue"], resolve);
          },
          meta: {
            activityType:28
          }
        }, 
        {
          path: "integralEden/firstPurchase", // 首单专享礼
          name: "firstPurchase",
          component: (resolve) => {
            require(["./views/integralCenter/actask/index.vue"], resolve);
          },
          meta: {
            activityType:17
          }
        }, 
        {
          path: "integralEden/repurchaseCourtesy", // 复购有礼
          name: "repurchaseCourtesy",
          component: (resolve) => {
            require(["./views/integralCenter/actask/index.vue"], resolve);
          },
          meta: {
            activityType:18
          }
        }, 
        {
          path: "integralEden/orderPolitely", // 下单有礼
          name: "orderPolitely",
          component: (resolve) => {
            require(["./views/integralCenter/actask/index.vue"], resolve);
          },
          meta: {
            activityType:16
          }
        }, 
        {
          path: "integralEden/orderLottery", // 下单抽奖
          name: "orderLottery",
          component: (resolve) => {
            require(["./views/integralCenter/actask/index.vue"], resolve);
          },
          meta: {
            activityType:19
          }
        }, 
        {
          path: "integralEden/orderRank", // 下单抽奖
          name: "orderRank",
          component: (resolve) => {
            require(["./views/integralCenter/actask/index.vue"], resolve);
          },
          meta: {
            activityType:36
          }
        }, 
        {
          path: "integralEden/evaluatePolitely", // 评价有礼
          name: "evaluatePolitely",
          component: (resolve) => {
            require(["./views/integralCenter/actask/index.vue"], resolve);
          },
          meta: {
            activityType:20
          }
        }, 
        {
          path: "integralEden/postOrders", // 晒单有礼
          name: "postOrders",
          component: (resolve) => {
            require(["./views/integralCenter/actask/index.vue"], resolve);
          },
          meta: {
            activityType:41
          }
        }, 
        {
          path: "fisionMarketing/fissionActivityList", // 裂变营销 活动列表
          name: "fissionActivityList",
          component: (resolve) => {
            require(["./views/integralCenter/activityManage.vue"], resolve);
          },
          meta: {
            activityNewMainTypes:3
          }
        }, 
        {
          path: "fisionMarketing/invitationCard", // 邀请开卡有礼
          name: "invitationCard",
          component: (resolve) => {
            require(["./views/integralCenter/actask/index.vue"], resolve);
          },
          meta: {
            activityType:4
          }
        }, 
        {
          path: "fisionMarketing/inviteFollowStore", // 邀请关注有礼
          name: "inviteFollowStore",
          component: (resolve) => {
            require(["./views/integralCenter/actask/index.vue"], resolve);
          },
          meta: {
            activityType:5
          }
        }, 
        {
          path: "fisionMarketing/fissionDivine", //  裂变神券
          name: "fissionDivine",
          component: (resolve) => {
            require(["./views/integralCenter/actask/index.vue"], resolve);
          },
          meta: {
            activityType:21
          }
        }, 
        {
          path: "fisionMarketing/superFissionDivine", //  超级裂变神券
          name: "superFissionDivine",
          component: (resolve) => {
            require(["./views/integralCenter/actask/index.vue"], resolve);
          },
          meta: {
            activityType:31
          }
        }, 
        {
          path: "fisionMarketing/loveLetterGreetingCard", // 情书贺卡
          name: "loveLetterGreetingCard",
          component: (resolve) => {
            require(["./views/integralCenter/actask/index.vue"], resolve);
          },
          meta: {
            activityType:50
          }
        },
        {
          path: "interestDraw/drawActivityList", // 趣味抽奖 活动列表
          name: "drawActivityList",
          component: (resolve) => {
            require(["./views/integralCenter/activityManage.vue"], resolve);
          },
          meta: {
            activityNewMainTypes:4
          }
        }, 
        {
          path: "interestDraw/turntableLottery", //  幸运抽奖
          name: "turntableLottery",
          component: (resolve) => {
            require(["./views/integralCenter/actask/index.vue"], resolve);
          },
          meta: {
            activityType:8
          }
        }, 
        {
          path: "gameHub/gameActivityList", // 游戏中心 活动列表
          name: "gameActivityList",
          component: (resolve) => {
            require(["./views/integralCenter/activityManage.vue"], resolve);
          },
          meta: {
            activityNewMainTypes:5
          }
        }, 
        {
          path: "gameHub/redpackRain", //  天降红包雨
          name: "redpackRain",
          component: (resolve) => {
            require(["./views/integralCenter/actask/index.vue"], resolve);
          },
          meta: {
            activityType:22
          }
        }, 
        {
          path: "gameHub/catchDoll", //  抓娃娃
          name: "catchDoll",
          component: (resolve) => {
            require(["./views/integralCenter/actask/index.vue"], resolve);
          },
          meta: {
            activityType:23
          }
        }, 
        {
          path: "gameHub/findDiffer", //  大家来找茬
          name: "findDiffer",
          component: (resolve) => {
            require(["./views/integralCenter/actask/index.vue"], resolve);
          },
          meta: {
            activityType:24
          }
        }, 
        {
          path: "integralMall/exchangeCoupon", //  优惠券
          name: "exchangeCoupon",
          component: (resolve) => {
            require(["./views/integralCenter/actask/index.vue"], resolve);
          },
          meta: {
            activityType:10
          }
        }, 
        {
          path: "integralMall/exchangeGift", //  实物
          name: "exchangeGift",
          component: (resolve) => {
            require(["./views/integralCenter/actask/index.vue"], resolve);
          },
          meta: {
            activityType:9
          }
        }, 
        {
          path: "integralMall/exchangeBean", //  京豆
          name: "exchangeBean",
          component: (resolve) => {
            require(["./views/integralCenter/actask/index.vue"], resolve);
          },
          meta: {
            activityType:29
          }
        }, 
        {
          path: "integralMall/exchangeEcard", //  E卡
          name: "exchangeEcard",
          component: (resolve) => {
            require(["./views/integralCenter/actask/index.vue"], resolve);
          },
          meta: {
            activityType:30
          }
        },
        {
          path: "integralMall/exchangeCashRed", //  红包
          name: "exchangeCashRed",
          component: (resolve) => {
            require(["./views/integralCenter/actask/index.vue"], resolve);
          },
          meta: {
            activityType:38
          }
        },
        {
          path: "integralMall/exchangeAqyMember", //  爱奇艺会员
          name: "exchangeAqyMember",
          component: (resolve) => {
            require(["./views/integralCenter/actask/index.vue"], resolve);
          },
          meta: {
            activityType: 58
          }
        },
        {
          path: "integralMall/exchangePlusMember", //    PLUS会员
          name: "exchangePlusMember",
          component: (resolve) => {
            require(["./views/integralCenter/actask/index.vue"], resolve);
          },
          meta: {
            activityType: 59
          }
        },
        {
          path: "integralMall/exchangeGiftCard", //  礼品卡
          name: "exchangeGiftCard",
          component: (resolve) => {
            require(["./views/integralCenter/actask/index.vue"], resolve);
          },
          meta: {
            activityType: 60
          }
        },
        {
          path: "integralMall/exchangeBaiduNetdisk", //  百度网盘
          name: "exchangeBaiduNetdisk",
          component: (resolve) => {
            require(["./views/integralCenter/actask/index.vue"], resolve);
          },
          meta: {
            activityType: 61
          }
        },
        {
          path: "throw", //  投放
          name: "throw",
          component: (resolve) => {
            require(["./views/integralCenter/throw/index.vue"], resolve);
          },
        },
        {
          path: "lock_auth_throw", //  积分锁权 投放
          name: "lock_auth_throw",
          component: (resolve) => {
            require(["./views/integralCenter/throw/lockAuthThrow.vue"], resolve);
          },
        },
        
      ],
    },
    //店铺装修
    {
      path: "/draw",
      component: (resolve) => {
        require(["./views/integralCenter/draw/draw.vue"], resolve)
      },
    },
  ],
});
